import { routerComponents } from './routerComponents';

const customRoutes = [
  {
    name: 'customPageSaugu',
    path: '/saugu/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/saugu/puslapis/saugu',
    },
  },
  {
    name: 'customPageUefaTransliacijos',
    path: '/uefa-transliacijos/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/puslapis/uefa-transliacijos',
    },
  },
  {
    name: 'customPageEurobasket',
    path: '/sportas/eurobasket-2025/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/sportas/puslapis/eurobasket-2025',
    },
  },
  {
    name: 'customPageEuroleague',
    path: '/krepsinis/eurolyga/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/krepsinis/puslapis/eurolyga',
    },
  },
  {
    name: 'customPageDakar',
    path: '/sportas/dakaras/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/sportas/puslapis/dakaras',
    },
  },
  {
    name: 'customPageWO',
    path: '/sportas/ziemos-olimpines-zaidynes/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/sportas/puslapis/ziemos-olimpines-zaidynes',
    },
  },
  {
    name: 'customPageTvShows',
    path: '/tv/laidos/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/tv/puslapis/laidos',
    },
  },
  {
    name: 'customPageRuWeather',
    path: '/ru/pogoda/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/ru/stranica/pogoda',
    },
  },
  {
    name: 'customPageStudijos',
    path: '/projektai/studijos/:page?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/projektai/puslapis/studijos',
    },
  },
  {
    name: 'customPageMunicipalities',
    path: '/savivaldybiu-reitingas/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/puslapis/savivaldybiu-reitingas',
    },
  },
  {
    name: 'customPageTelia',
    path: '/projektai/technologijos-kiekvienai-dienai/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/projektai/puslapis/technologijos-kiekvienai-dienai',
    },
  },
  {
    name: 'customPageMunicipalElections',
    path: '/meru-rinkimai/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/puslapis/meru-rinkimai',
    },
  },
  {
    name: 'customPageItakingiausieji',
    path: '/itakingiausieji-2026/:page?/:subpage?',
    component: routerComponents.Custom,
    props: {
      customRoute: '/puslapis/itakingiausieji-2026',
    },
  },
];

export default customRoutes;
